export default __webpack_public_path__ + "static/media/goshen59.67db3591.jpg";